<template>
    <div>
        <!-- Parent Relations -->
        <!-- Collection items come from two indices -->
        <a :href="view('mariners_collection,monitor_collection', object._id, true)" v-if='ownedByCollectionTotal'>
            Items ({{ownedByCollectionTotal}})
        </a>

        <!-- All others come from one index -->
        <div v-for='count, index in object.relation_count.parent'>
             <a :href="view(index, object._id, true)" v-if='index != "mariners_collection" && index != "monitor_collection"'>
                <span v-if='index == "archival_collection"'>Archival Collection ({{count}})</span>
                <span v-else-if='index == "archival_series"'>Archival Series ({{count}})</span>
                <span v-else-if='index == "archival_fileunit"'>Archival File Units ({{count}})</span>
                <span v-else-if='index == "archival_item"'>Archival Items ({{count}})</span>
                <span v-else-if='index == "library"'>Library ({{count}})</span>
                <!-- Associations are done separatly -->
                <!-- <span v-else-if='index == "association"'>Association ({{count}})</span> -->
                <span v-else-if='index == "exhibit"'>Exhibits ({{count}})</span>
                <span v-else-if='index == "vessel"'>Vessels ({{count}})</span>
            </a>
        </div>

        <!-- Child Relations -->
        <!-- Collection items come from two indices -->
        <a :href="view('mariners_collection,monitor_collection', object._id, false)" v-if='ownsCollectionTotal > 0'>
            Items ({{ownsCollectionTotal}})
        </a>

        <!-- All others come from one index -->
        <div v-for='count, index in object.relation_count.child'>
            <a :href="view(index, object._id, false)">
                <span v-if='index == "archival_collection"'>Archival Collection ({{count}})</span>
                <span v-else-if='index == "archival_series"'>Archival Series ({{count}})</span>
                <span v-else-if='index == "archival_fileunit"'>Archival File Units ({{count}})</span>
                <span v-else-if='index == "archival_item"'>Archival Items ({{count}})</span>
                <span v-else-if='index == "collection"'>Items ({{count}})</span>
                <span v-else-if='index == "library"'>Library ({{count}})</span>
                <!-- Associations are done separatly -->
                <!-- <span v-else-if='index == "association"'>Association ({{count}})</span> -->
                <span v-else-if='index == "exhibit"'>Exhibits ({{count}})</span>
                <span v-else-if='index == "vessel"'>Vessels ({{count}})</span>
            </a>
        </div>
    </div>
</template>`

<script>
    import ViewRelated from '../../../mixins/viewRelated.js'
    import FilterManager from '../../filterManager.js'

    export default {
        mixins: [ViewRelated],
        props: ['object'],
        methods: {
            view: function (index, id, generate_owns) {
                var indices = index.split(',')
                var query = {'indices': indices}

                if (generate_owns) {
                    query['child-keyword'] = id
                } else {
                    query['parent-keyword'] = id
                }

                // FilterManager.clearAll()
                // this.viewRelated(query, true)
                return this.generateLink(query, true)
            }
        },
        computed: {
            ownedByCollectionTotal: function () {
                var mariners = 0
                var monitor = 0

                if (this.object.relation_count.parent) {
                    if (this.object.relation_count.parent.mariners_collection) {
                        mariners = this.object.relation_count.parent.mariners_collection
                    }

                    if (this.object.relation_count.parent.monitor_collection) {
                        monitor = this.object.relation_count.parent.monitor_collection
                    }
                }

                return mariners + monitor
            },
            ownsCollectionTotal: function () {
                var mariners = 0
                var monitor = 0
                if (this.object.relation_count.child) {
                    if (this.object.relation_count.child.mariners_collection) {
                        mariners = this.object.relation_count.child.mariners_collection
                    }

                    if (this.object.relation_count.child.monitor_collection) {
                        monitor = this.object.relation_count.child.monitor_collection
                    }
                }

                return mariners + monitor
            }
        }
    }
</script>
